import { NotificacaoCanal, NotificacaoTemplate, StatusEnvioNotificacao } from '../generated/backend-enums.js';
export { NotificacaoCanal, NotificacaoTemplate, StatusEnvioNotificacao };
export const NotificacaoCanalMap = {
    [NotificacaoCanal.EMAIL]: 'E-mail',
    [NotificacaoCanal.WHATSAPP]: 'WhatsApp',
    [NotificacaoCanal.SMS]: 'SMS',
    [NotificacaoCanal.INBOX]: 'Hub Inbox',
};
export const StatusEnvioNotificacaoMap = {
    [StatusEnvioNotificacao.ENVIADA]: 'Enviada',
    [StatusEnvioNotificacao.IGNORADA]: 'Ignorada',
    [StatusEnvioNotificacao.FALHA]: 'Falha',
};
export const NotificacaoTemplateMap = {
    [NotificacaoTemplate.BOAS_VINDAS]: 'Boas-vindas',
    [NotificacaoTemplate.APROVACAO_PENDENTE]: 'Aprovação pendente (sua vez)',
    [NotificacaoTemplate.ETAPA_PULADA_APROVACAO]: 'Etapa de aprovação pulada',
    [NotificacaoTemplate.INICIO_APROVACAO_VERSAO]: 'Início de aprovação de versão',
    [NotificacaoTemplate.VERSAO_APROVADA_INTERNAMENTE]: 'Versão aprovada internamente',
    [NotificacaoTemplate.VERSAO_APROVADA]: 'Versão aprovada',
    [NotificacaoTemplate.VERSAO_APROVADA_COMPRADORES]: 'Versão aprovada (compradores)',
    [NotificacaoTemplate.VERSAO_APROVADA_TI]: 'Versão aprovada (tecnologia)',
    [NotificacaoTemplate.VERSAO_APROVADA_PARCIALMENTE]: 'Versão aprovada parcialmente',
    [NotificacaoTemplate.VERSAO_APROVADA_PARCIALMENTE_COMPRADORES]: 'Versão aprovada parcialmente (compradores)',
    [NotificacaoTemplate.VERSAO_REPROVADA]: 'Versão reprovada',
    [NotificacaoTemplate.VERSAO_DESAPROVADA]: 'Versão desaprovada',
    [NotificacaoTemplate.REQUISITAR_MODERACAO_VERSAO]: 'Moderação de versão solicitada',
    [NotificacaoTemplate.COMPRA_CRIADA]: 'Compra criada',
    [NotificacaoTemplate.PRODUTOR_FINANCEIRO_ALTERADO]: 'Produtor financeiro alterado',
    [NotificacaoTemplate.PRODUTOR_GRAFICO_ALTERADO]: 'Produtor gráfico alterado',
    [NotificacaoTemplate.GANHO_REAL_ALTERADO]: 'Ganho real alterado',
    [NotificacaoTemplate.PLANILHA_VINCULADA_AP]: 'Planilha vinculada à AP',
    [NotificacaoTemplate.CRIACAO_PEDIDO_FATURAMENTO]: 'Pedido de faturamento criado',
    [NotificacaoTemplate.CANCELAR_PEDIDO_FATURAMENTO]: 'Pedido de faturamento cancelado',
    [NotificacaoTemplate.CONCLUIR_PEDIDO_FATURAMENTO]: 'Pedido de faturamento concluído',
    [NotificacaoTemplate.REPROVAR_PEDIDO_FATURAMENTO]: 'Pedido de faturamento reprovado',
    [NotificacaoTemplate.DESFAZER_PEDIDO_FATURAMENTO]: 'Pedido de faturamento desfeito',
    [NotificacaoTemplate.FATURAMENTOS_PAGOS]: 'Faturamentos pagos',
    [NotificacaoTemplate.APROVACAO_ETAPA_PENDENTE]: 'Aprovação com etapa pendente',
    [NotificacaoTemplate.APROVACAO_FINALIZADA]: 'Aprovação finalizada',
    [NotificacaoTemplate.DESPESA_APROVACAO_ETAPA_PENDENTE]: 'Despesa com etapa de aprovação pendente',
    [NotificacaoTemplate.DESPESA_APROVACAO_FINALIZADA]: 'Aprovação de despesa finalizada',
    [NotificacaoTemplate.COMISSAO_APROVACAO_ETAPA_PENDENTE]: 'Comissão com etapa de aprovação pendente',
    [NotificacaoTemplate.COMISSAO_APROVACAO_FINALIZADA]: 'Aprovação de comissão finalizada',
    [NotificacaoTemplate.JUSTIFICATIVA_SIMILARIDADE]: 'Justificativa de similaridade',
    [NotificacaoTemplate.SIMILARIDADE_DETECTADA]: 'Similaridade detectada',
    [NotificacaoTemplate.NOVA_MENSAGEM_TAREFA]: 'Nova mensagem na tarefa',
    [NotificacaoTemplate.SOLICITACAO_AP_PLANILHA]: 'AP da planilha solicitada',
    [NotificacaoTemplate.QUESTIONAR_VERSAO]: 'Versão questionada',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_VERSAO]: 'Questionamento de versão concluído',
    [NotificacaoTemplate.SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO]: 'Planilha de atendimento questionada',
    [NotificacaoTemplate.CONCLUIDO_SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO]: 'Questionamento de planilha de atendimento concluído',
    [NotificacaoTemplate.QUESTIONAR_ARQUIVO_APROVACAO]: 'Arquivo de aprovação questionado',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_ARQUIVO_APROVACAO]: 'Questionamento de arquivo de aprovação concluído',
    [NotificacaoTemplate.QUESTIONAR_JOB]: 'Job questionado',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_JOB]: 'Questionamento de job concluído',
    [NotificacaoTemplate.QUESTIONAR_BRIEFING]: 'Briefing questionado',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_BRIEFING]: 'Questionamento de briefing concluído',
    [NotificacaoTemplate.QUESTIONAR_PAPER]: 'Paper questionado',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_PAPER]: 'Questionamento de paper concluído',
    [NotificacaoTemplate.CRIAR_CLIENTE_TAREFA]: 'Tarefa de criação de cliente',
    [NotificacaoTemplate.PEDIDO_ANIVERSARIO_CONTATOS]: 'Pedido de aniversários de contatos',
    [NotificacaoTemplate.PEDIDO_GIFT_AVISO_RESPONSAVEL]: 'Aviso de pedido de gift aos responsáveis',
    [NotificacaoTemplate.OBSERVADOR_ADICIONADO_TAREFA]: 'Observador adicionado à tarefa',
    [NotificacaoTemplate.OBSERVADOR_REMOVIDO_TAREFA]: 'Observador removido da tarefa',
    [NotificacaoTemplate.SOLICITAR_ORCAMENTO_PRE_PRODUCAO]: 'Orçamento de pré-produção solicitado',
    [NotificacaoTemplate.SOLICITAR_AJUSTE_AP]: 'AP questionada',
    [NotificacaoTemplate.CONCLUIDO_SOLICITAR_AJUSTE_AP]: 'Questionamento de AP concluído',
    [NotificacaoTemplate.COBRAR_APROVACAO_AP]: 'Cobrança de aprovação de AP',
    [NotificacaoTemplate.CONCLUIDO_COBRAR_APROVACAO_AP]: 'Cobrança de aprovação de AP concluída',
    [NotificacaoTemplate.SOLICITAR_DESFATURAMENTO]: 'Desfaturamento solicitado',
    [NotificacaoTemplate.DATA_PRAZO_ALTERADO_TAREFA]: 'Prazo da tarefa alterado',
    [NotificacaoTemplate.GRUPO_CREDITO_CRIADO]: 'Grupo de crédito criado',
    [NotificacaoTemplate.CREDITO_TRANSFERIDO]: 'Crédito transferido',
    [NotificacaoTemplate.ADICIONADO_COMO_SUBSTITUTO]: 'Adicionado como substituto',
};
/**
 * Agrupamento para a UI admin de regras de envio. Um `Record` sobre o enum
 * gerado: template novo sem grupo não compila.
 */
export const NotificacaoTemplateGrupoMap = {
    [NotificacaoTemplate.BOAS_VINDAS]: 'Sistema',
    [NotificacaoTemplate.ADICIONADO_COMO_SUBSTITUTO]: 'Sistema',
    [NotificacaoTemplate.APROVACAO_PENDENTE]: 'Aprovações',
    [NotificacaoTemplate.ETAPA_PULADA_APROVACAO]: 'Aprovações',
    [NotificacaoTemplate.APROVACAO_ETAPA_PENDENTE]: 'Aprovações',
    [NotificacaoTemplate.APROVACAO_FINALIZADA]: 'Aprovações',
    [NotificacaoTemplate.INICIO_APROVACAO_VERSAO]: 'Versões',
    [NotificacaoTemplate.VERSAO_APROVADA_INTERNAMENTE]: 'Versões',
    [NotificacaoTemplate.VERSAO_APROVADA]: 'Versões',
    [NotificacaoTemplate.VERSAO_APROVADA_COMPRADORES]: 'Versões',
    [NotificacaoTemplate.VERSAO_APROVADA_TI]: 'Versões',
    [NotificacaoTemplate.VERSAO_APROVADA_PARCIALMENTE]: 'Versões',
    [NotificacaoTemplate.VERSAO_APROVADA_PARCIALMENTE_COMPRADORES]: 'Versões',
    [NotificacaoTemplate.VERSAO_REPROVADA]: 'Versões',
    [NotificacaoTemplate.VERSAO_DESAPROVADA]: 'Versões',
    [NotificacaoTemplate.REQUISITAR_MODERACAO_VERSAO]: 'Versões',
    [NotificacaoTemplate.QUESTIONAR_VERSAO]: 'Versões',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_VERSAO]: 'Versões',
    [NotificacaoTemplate.COMPRA_CRIADA]: 'Compras',
    [NotificacaoTemplate.PRODUTOR_FINANCEIRO_ALTERADO]: 'Compras',
    [NotificacaoTemplate.PRODUTOR_GRAFICO_ALTERADO]: 'Compras',
    [NotificacaoTemplate.GANHO_REAL_ALTERADO]: 'Compras',
    [NotificacaoTemplate.PLANILHA_VINCULADA_AP]: 'APs',
    [NotificacaoTemplate.SOLICITACAO_AP_PLANILHA]: 'APs',
    [NotificacaoTemplate.SOLICITAR_AJUSTE_AP]: 'APs',
    [NotificacaoTemplate.CONCLUIDO_SOLICITAR_AJUSTE_AP]: 'APs',
    [NotificacaoTemplate.COBRAR_APROVACAO_AP]: 'APs',
    [NotificacaoTemplate.CONCLUIDO_COBRAR_APROVACAO_AP]: 'APs',
    [NotificacaoTemplate.SOLICITAR_ORCAMENTO_PRE_PRODUCAO]: 'APs',
    [NotificacaoTemplate.CRIACAO_PEDIDO_FATURAMENTO]: 'Faturamentos',
    [NotificacaoTemplate.CANCELAR_PEDIDO_FATURAMENTO]: 'Faturamentos',
    [NotificacaoTemplate.CONCLUIR_PEDIDO_FATURAMENTO]: 'Faturamentos',
    [NotificacaoTemplate.REPROVAR_PEDIDO_FATURAMENTO]: 'Faturamentos',
    [NotificacaoTemplate.DESFAZER_PEDIDO_FATURAMENTO]: 'Faturamentos',
    [NotificacaoTemplate.FATURAMENTOS_PAGOS]: 'Faturamentos',
    [NotificacaoTemplate.SOLICITAR_DESFATURAMENTO]: 'Faturamentos',
    [NotificacaoTemplate.DESPESA_APROVACAO_ETAPA_PENDENTE]: 'Custos de projeto',
    [NotificacaoTemplate.DESPESA_APROVACAO_FINALIZADA]: 'Custos de projeto',
    [NotificacaoTemplate.COMISSAO_APROVACAO_ETAPA_PENDENTE]: 'Custos de projeto',
    [NotificacaoTemplate.COMISSAO_APROVACAO_FINALIZADA]: 'Custos de projeto',
    [NotificacaoTemplate.JUSTIFICATIVA_SIMILARIDADE]: 'Planilhas',
    [NotificacaoTemplate.SIMILARIDADE_DETECTADA]: 'Planilhas',
    [NotificacaoTemplate.SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO]: 'Planilhas',
    [NotificacaoTemplate.CONCLUIDO_SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO]: 'Planilhas',
    [NotificacaoTemplate.NOVA_MENSAGEM_TAREFA]: 'Tarefas',
    [NotificacaoTemplate.CRIAR_CLIENTE_TAREFA]: 'Tarefas',
    [NotificacaoTemplate.PEDIDO_ANIVERSARIO_CONTATOS]: 'Tarefas',
    [NotificacaoTemplate.PEDIDO_GIFT_AVISO_RESPONSAVEL]: 'Contatos',
    [NotificacaoTemplate.OBSERVADOR_ADICIONADO_TAREFA]: 'Tarefas',
    [NotificacaoTemplate.OBSERVADOR_REMOVIDO_TAREFA]: 'Tarefas',
    [NotificacaoTemplate.DATA_PRAZO_ALTERADO_TAREFA]: 'Tarefas',
    [NotificacaoTemplate.QUESTIONAR_ARQUIVO_APROVACAO]: 'Tarefas',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_ARQUIVO_APROVACAO]: 'Tarefas',
    [NotificacaoTemplate.QUESTIONAR_JOB]: 'Tarefas',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_JOB]: 'Tarefas',
    [NotificacaoTemplate.QUESTIONAR_BRIEFING]: 'Tarefas',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_BRIEFING]: 'Tarefas',
    [NotificacaoTemplate.QUESTIONAR_PAPER]: 'Tarefas',
    [NotificacaoTemplate.CONCLUIDO_QUESTIONAR_PAPER]: 'Tarefas',
    [NotificacaoTemplate.GRUPO_CREDITO_CRIADO]: 'Créditos',
    [NotificacaoTemplate.CREDITO_TRANSFERIDO]: 'Créditos',
};
